var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",class:[
    `button--${_vm.variant}`,
    {
      'button--small': _vm.size === 'small',
      'button--icon': _vm.size === 'icon',
      'is-active': _vm.active,
    },
  ],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading,"aria-busy":_vm.loading ? 'true' : 'false',"aria-label":_vm.label,"title":_vm.label},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('Transition',{attrs:{"name":"button-spinner"}},[(_vm.loading)?_c('span',{staticClass:"button__spinner-slot",attrs:{"aria-hidden":"true"}},[_c('Spinner',{attrs:{"size":"0.85em"}})],1):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }